export class GenericMessage {
  /**
   * Is this an error related to a specific carrier's data?
   */
  carrier?: string;
  code: string;
  field: string;
  message: string;
}

export class CampaignIssue {
  field: string;
  severity: string;
  message: string;
}

export class GenericResponse {
  public status: string;
  public messages: GenericMessage[];
}
